import Project from "../main.js";
import {News} from "../components/news.js";

export class OrderForm {
	constructor() {
		this.project = new Project()

		this.DOM = {
			orderForm: this.project.DOM.body.querySelector('#orderForm'),
			datesSelectionInput: this.project.DOM.body.querySelector('#dates'),
			showSecondPersonCheckbox: this.project.DOM.body.querySelector('#showSecondPerson'),
			showSecondPersonPart: this.project.DOM.body.querySelector('#secondPerson'),
		}

		this.init()
	}

	init() {
		this.handleDatepicker();
		this.handleEvents();
	}

	handleDatepicker() {
		if(!window.flatpickr) {
			this.DOM.datesSelectionInput.setAttribute('type', 'date');
			return
		}

		window.flatpickr(this.DOM.datesSelectionInput, {
			mode: 'multiple',
			locale: 'cs',
			minDate: this.DOM.datesSelectionInput.getAttribute('min'),
		})
	}

	handleEvents() {
		this.DOM.showSecondPersonCheckbox?.addEventListener('click', this.toggleSecondPersonPart.bind(this))
	}

	toggleSecondPersonPart() {
		this.DOM.showSecondPersonPart?.classList.toggle(
			'hidden',
			!this.DOM.showSecondPersonCheckbox.checked
		)
	}
}